import { Outlet } from 'react-router-dom';

const ActivitiesLayout = () => {
	return <Outlet />;
};
export default ActivitiesLayout;
